import React from 'react';
import { FaRegEnvelope } from 'react-icons/fa';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import { decode } from 'html-entities';

interface Props {
  messageContent: string;
  department: MessageDepartment;
}

export type MessageDepartment =
  | 'manufacturing'
  | 'shipping'
  | 'delivery'
  | 'store';

const DEPARTMENT_PRESENTATION: Record<
  MessageDepartment,
  { label: string; badgeClassName: string; borderClassName: string }
> = {
  manufacturing: {
    label: 'Fabrication',
    badgeClassName: 'bg-orange',
    borderClassName: 'border-orange-light',
  },
  shipping: {
    label: 'Expédition',
    badgeClassName: 'bg-blue',
    borderClassName: 'border-blue-light',
  },
  delivery: {
    label: 'Livraison',
    badgeClassName: 'bg-green',
    borderClassName: 'border-green-light',
  },
  store: {
    label: 'Magasin',
    badgeClassName: 'bg-purple',
    borderClassName: 'border-purple-light',
  },
};

const MessageOrder = ({ messageContent, department }: Props) => {
  const data = messageContent.split('%%%');
  let message = data[0];
  const date = new Date(data[1]);
  const employee = data[2];
  const hasMetadata = Boolean(employee) && !Number.isNaN(date.getTime());
  const presentation = DEPARTMENT_PRESENTATION[department];

  // Remove the first character if it is '/'
  if (message.startsWith('/')) {
    message = message.slice(1);
  }

  // Decode HTML entities
  message = decode(message);

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between w-full">
        <div
          className={`flex justify-center items-center ml-2 text-white w-32 py-1 z-10 ${presentation.badgeClassName}`}
        >
          <FaRegEnvelope className="h-4 w-4 mx-2" />
          {presentation.label}
        </div>
        {hasMetadata && (
          <div className="flex text-sm">
            <div className="-mt-1 mr-2 font-semibold">{employee}</div>
            <div className="-mt-1 mr-2 italic text-sm">
              Il y a {formatDistanceToNow(date, { locale: fr })}
            </div>
          </div>
        )}
      </div>

      <div
        className={`whitespace-pre-line bg-gray-100 p-2 mb-4 mx-2 border ${presentation.borderClassName}`}
      >
        {message}
      </div>
    </div>
  );
};

export default MessageOrder;
